import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const TableWrapperClassName = `${CLASS_NAME_PREFIX}-table-wrapper`;
export const TableClassName = `${CLASS_NAME_PREFIX}-table`;
export const TableHeaderClassName = `${TableClassName}__header`;
export const TableBodyClassName = `${TableClassName}__body`;
export const TableHeaderRowClassName = `${TableHeaderClassName}-row`;
export const TableHeaderCellClassName = `${TableHeaderRowClassName}-cell`;
export const TableBodyRowClassName = `${TableBodyClassName}-row`;
export const TableBodyCellClassName = `${TableBodyRowClassName}-cell`;
